import React, { useContext, useState } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';


const Footer = () => {
  const { t, language } = useContext(LanguageContext);
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <Link to={`/${language.value}/`} className="logo">
                  <img
                    src="/images/logo.png"
                    alt="Hostel Nut Logo"
                    className="footer-logo-image"
                  />
                </Link>
              </div>

            </div>
            <p className="footer-description">
              {t("footer", "description")}
            </p>
          </div>

          {/* Navigate Links */}
          <div className="footer-links-section">
            <h4 className="footer-links-title">{t("footer", "navigate")}</h4>
            <Link to={`/${language.value}/`} className="footer-link">{t("nav", "home")}</Link>
            <Link to={`/${language.value}/rooms`} className="footer-link">{t("nav", "rooms")}</Link>
            <Link to={`/${language.value}/location`} className="footer-link">{t("nav", "location")}</Link>
            <Link to={`/${language.value}/gallery`} className="footer-link">{t("nav", "gallery")}</Link>
          </div>

          {/* Company Links */}
          <div className="footer-links-section">
            <h4 className="footer-links-title">Company</h4>
            <Link to={`/${language.value}/faqs`} className="footer-link">FAQs</Link>
          </div>

          {/* Legal Links */}
          <div className="footer-links-section">
            <h4 className="footer-links-title">Legal</h4>
            <Link to={`/${language.value}/terms-and-conditions`} className="footer-link">Terms & Conditions</Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <p>© 2025 HostelNut. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;